module.exports = __webpack_public_path__ + "fonts/sourcesansproextralightitalic.ad3083af.ttf";